/**
 * Checks whether or not the app has been loaded within a marketing `iframe`.
 *
 * See https://gobonfire.com/bonfire-premium-vendors/
 *
 * @returns {Boolean} Returns `true` if an `iframe` is detected, otherwise `false`.
 */
export const checkMarketingiFrameExists = () => window !== window?.parent;
